import { render, staticRenderFns } from "./ProductModelDetail.vue?vue&type=template&id=b2b4bc92&scoped=true"
import script from "./ProductModelDetail.vue?vue&type=script&lang=js"
export * from "./ProductModelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b4bc92",
  null
  
)

export default component.exports